<section class="event-sec selectPreventer">
  <div class="event-page-sports" id="eventpagesports">
    <h4 class="ng-star-inserted">{{ 'Upcoming' | t }}</h4>
  </div>

  <mat-button-toggle-group id="eventpagesportsmattoogle" class="eventsHeader" (valueChange)="oddMarketingChange($event)" value="0">
    <mat-button-toggle value="0">
      <span>{{ 'tipp' | t }}</span>
    </mat-button-toggle>
    <mat-button-toggle value="1">
      <span>{{ 'hc' | t }}</span>
    </mat-button-toggle>
    <mat-button-toggle value="2">
      <span>{{ 'O/U' | t }}</span>
    </mat-button-toggle>
    <mat-button-toggle value="3">
      <span>{{ 'DC' | t }}</span>
    </mat-button-toggle>
    <mat-button-toggle value="4">
      <span>{{ 'TF?' | t }}</span>
    </mat-button-toggle>
    <mat-button-toggle value="5">
      <span>{{ 'NT' | t }}</span>
    </mat-button-toggle>
    <mat-button-toggle value="6">
      <span>{{ 'TIPP 1.HZ' | t }}</span>
    </mat-button-toggle>
    <mat-button-toggle value="7">
      <span>{{ 'Ü/U 1.HZ' | t }}</span>
    </mat-button-toggle>
  </mat-button-toggle-group>

  <!--<prematch-component (favChanged)="favsChanged()" [oddMarketingValue]="this.oddMarketingValue" [preMatchobservable]="this.favPreMatchobservable" [_selectedOdds]="this._selectedOdds"></prematch-component>-->

  <prematch-component
    (favChanged)="getFavs()"
    [oddMarketingValue]="this.oddMarketingValue"
    [preMatchobservable]="this.preMatchobservable"
    [_selectedOdds]="this._selectedOdds"></prematch-component>
</section>
